export const JOB_SEARCH_MILES_RANGES = [5, 10, 25, 50, 75, 100, 200] as const;

export type JOB_SEARCH_MILES_RANGES_TYPE =
  (typeof JOB_SEARCH_MILES_RANGES)[number];

export const PROFILE_MILES_RANGES = [5, 10, 25, 50, 75, 100] as const;

export const DEFAULT_MILE_RANGE = JOB_SEARCH_MILES_RANGES[6];

export const STAGING_HOSTNAME = "dev.hirenimble.com";
export const PRODUCTION_HOSTNAME = "app.hirenimble.com";

export const SUPPORT_EMAIL = "connectsupport@hirenimble.com";
export const HIRE_SUPPORT_EMAIL = "support@hirenimble.com";

export const GATEWAY_PROXY_PATH = `/proxy`;
export const REVERSE_PROXY_GATEWAY_PATH = `/api-gateway${GATEWAY_PROXY_PATH}`;

export const NimbleProduct = {
  ATS: "ats",
  CONNECT: "connect",
} as const;
